export default __webpack_public_path__ + "static/media/react-dom.88333829.gif";